export default __webpack_public_path__ + "static/media/slide-active.37928509.svg";